import { useEffect, useMemo } from "react";
import useCurrentDate from "../../../Utils/useCurrentDate";
import moment from "moment";

export default function useWeekPicker(
    week: number,
    onChange: (week: number) => void
) {
    useEffect(() => onChange(week), [week]);

    const { startDate, endDate, time } = useCurrentDate();

    // 当前时间是否在所选择学期内
    const isCurrentBatch = useMemo(
        () => time.isBetween(moment(startDate), moment(endDate)),
        [startDate, endDate, time]
    );

    return { isCurrentBatch };
}
